export default __webpack_public_path__ + "static/media/pdf.6279a47b.png";